import { useSelector } from 'react-redux';
import { getProfilePermissions } from '@client/context/redux/redux';
import { hasPermissions } from '@client/context/utils/permissions';

export const usePermissionsValidator = (): (permissionsRequired: string[]) => boolean => {
  const debitorPermissions = useSelector(getProfilePermissions);

  return permissionsRequired => hasPermissions(permissionsRequired, debitorPermissions);
};
